import React, { useEffect } from "react";
import CrmEmpty from "../CrmEmpty";
import { Row, Col, Table, Spin } from "antd";
import StringHelper from '../../../helpers/StringHelper';
import moment from 'moment-jalaali';
import strings from '../../../../utils/strings';
import CrmCallItem from "./CrmCallItems"
import { useGeneralStore } from "../../../../store/slices/createGeneralSlice";
import { useReportsStore } from "../../../../store/slices/createReportsSlice";



export default function CrmCallHistoryReason({ callHistoryId }) {
    const general = useGeneralStore();

    const reports = useReportsStore()
    const data = reports.crmCallHistoryReason.data.Items;
    const CallStatus = reports.crmCallHistoryReason.data.CallStatus;
    const loading = reports.crmCallHistoryReason.loading;


    useEffect(() => {
        reports.getCrmCallHistoryReason(callHistoryId);
    }, [])


    const columns = [
        {
            title: 'کد',
            dataIndex: 'Id',
            width: 20,
            render: (text) => StringHelper.getFarsiNum(text)
        },
        {
            title: 'تاریخ ثبت',
            dataIndex: 'CreationTime',
            key: 'CreationTime',
            width: 20,
            render: data => data && strings.getFarsiNum(moment(data).format('jYYYY/jMM/jDD'))
        },
        {
            title: "شکایت",
            dataIndex: "IsProtest",
            width: 20,
            key: "IsProtest",
            render: data => data && (data.IsProtest == true ? "ندارم" : "دارم")

        },

        {
            title: "توضیحات",
            dataIndex: "Description",
            width: 300,
            key: "Description",
            render: text => <span style={{ color: '#5ec393' }}>{text}</span>,
        },

    ];

    return (
        <>
            <Spin spinning={loading}>
                <Row
                    gutter={[16, 16]}>
                    {CallStatus === 1 &&
                        <Col span={24}>
                            <button type="primary" className="btn btn-primary waves-effect waves-light float-left"
                                onClick={() => general.ToggleCrmCallItemsModal()}>
                                <i className="fas fa-plus font-size-14 align-middle mr-2"></i>  تماس مجدد
                            </button>
                        </Col>}
                    <Col span={24}>

                        <div className="animated fadeIn">
                            <div className="profile-header">

                                {data && data.length > 0 ?

                                    <Table
                                        style={{ overflowX: 'scroll' }}
                                        size="small"
                                        className="custom-table crm-request-report"
                                        bordered
                                        loading={loading}
                                        rowKey="ID"
                                        scroll={true}
                                        dataSource={data}
                                        columns={columns}
                                    />
                                    :
                                    <CrmEmpty text="یافت نشد" />}
                            </div>
                        </div>
                        <CrmCallItem callHistoryId={callHistoryId} />
                    </Col>
                </Row>
            </Spin>
        </>

    )
}